import { ApiEndPoints } from "../../models/api-endpoint";
import RestApiService from "../../services/http-services";
import Toaster from "../../services/toaster.services";
import { HIDE_CLUSTER_NODE_SUCCESS } from "../types/clusterNodeTypes";
import {
  FETCH_NODE_LIST_FAILURE,
  FETCH_NODE_LIST_SUCCESS,
  FETCH_NODE_LIST_REQUEST,
  FETCH_NODE_LIST_UPDATE,
} from "../types/fetchNodeListType";

// Main fetch node list action
export const fetchNodeList = (
  nodeETId,
  nodeSV,
  toggleLoader,
  hiddenClusterNodes = []
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_NODE_LIST_REQUEST });
      toggleLoader(true);

      const res = await RestApiService.invoke(
        ApiEndPoints.GET_NODE_LIST,
        null,
        null,
        null,
        { ETId: nodeETId, SV: nodeSV }
      );

      toggleLoader(false);

      let nodesToDisplay = res.data?.data || [];

      if (hiddenClusterNodes.length > 0) {
        const hiddenIds = new Set(hiddenClusterNodes.map((item) => item._id));
        nodesToDisplay = nodesToDisplay.filter(
          (node) => !hiddenIds.has(node._id)
        );
      }

      dispatch({
        type: FETCH_NODE_LIST_SUCCESS,
        payload: nodesToDisplay,
      });
    } catch (error) {
      toggleLoader(false);
      Toaster.errorToaster("Something went wrong");
      dispatch({
        type: FETCH_NODE_LIST_FAILURE,
        payload: "Failed to fetch node list",
      });
    }
  };
};

// Optional utility to manually set a filtered list
export const setFilteredNodeList = (nodeList) => {
  return (dispatch) => {
    try {
      dispatch({
        type: FETCH_NODE_LIST_SUCCESS,
        payload: nodeList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_NODE_LIST_FAILURE,
        payload: error,
      });
    }
  };
};
// action to push the hidden nodes in the cluster node state

export const updateNodeListWithHiddenNodes = (
  nodesToBeUpdated,
  hiddenNodesList
) => {
  return (dispatch) => {
    try {
        const existingIds = new Set(nodesToBeUpdated.map(node => node._id));
        const filteredData = hiddenNodesList.filter(node => !existingIds.has(node._id));

      dispatch({
        type: FETCH_NODE_LIST_UPDATE,
        payload: nodesToBeUpdated,
      });

      dispatch({
        type:HIDE_CLUSTER_NODE_SUCCESS,
        payload:filteredData
      })
    } catch (error) {
      dispatch({
        type: FETCH_NODE_LIST_FAILURE,
        payload: error,
      });
    }
  };
};
